//import { authStore, getRefreshToken, getToken } from '../store/auth/authStore'
import { BASE_URL, IS_DEBUG } from '../constants'
import { Auth } from 'aws-amplify'

export const getReq = async (p: any): Promise<any> => {
  const token = (await Auth.currentSession()).getIdToken().getJwtToken()
  //const token = (await Auth.currentSession()).getAccessToken().getJwtToken()

  return fetch(p, {
    method: 'GET',
    headers: {
      //Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      const contentType = res.headers.get('Content-Type')
      const isJson = contentType && contentType.indexOf('application/json') > -1

      if (IS_DEBUG) {
        console.log(' API > DEBUG res.status = ', res.status, res.statusText)
      }

      if (res.status === 404) {
        console.log(' API > res = ', res)
        const url = res.url || ''
        return Promise.reject(getErrorResponse(res, 404, 'Could not find endpoint ' + url))
      }

      if (res.status === 401) {
        console.log(' API GET > 401 401 401 401401 = ')
        return
      }

      if (!isJson) {
        return res.text()
      }

      return res.json()
    })
    .then((res) => {
      if (res.error || res.result === false) {
        return Promise.reject(res)
      }

      return res
    })

    .catch((err) => {
      console.log(' API > err = ', err)
      return Promise.reject(err)
    })
}

export const post = async (p: string, data: any) => {
  //const token = getToken()

  const token = (await Auth.currentSession()).getIdToken().getJwtToken()

  return fetch(p, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (IS_DEBUG) {
        console.log(' API > res.status = ', res.status, p)
      }

      if (res.status === 401) {
        console.log(' API POST > 401 401 401 401401 = ')
        return Promise.reject(res)
        //return updateAccessToken(p, 'POST', data)
      }

      return res.json()
    })
    .then((res) => {
      if (res.result === false) {
        return Promise.reject(res)
      }
      return res
    })

    .catch((err) => {
      return Promise.reject(err)
    })
}

export const put = async (p: string, data: any) => {
  //const token = getToken()
  const token = (await Auth.currentSession()).getIdToken().getJwtToken()

  return fetch(p, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (IS_DEBUG) {
        console.log(' API > res.status = ', res.status, p)
      }

      if (res.status === 401) {
        console.log(' API PUT > 401 401 401 401401 = ')
        return Promise.reject(res)
        //return updateAccessToken(p, 'POST', data)
      }

      return res.json()
    })
    .then((res) => {
      if (res.result === false) {
        return Promise.reject(res)
      }
      return res
    })

    .catch((err) => {
      return Promise.reject(err)
    })
}

export const destroy = async (p: string, data?: any) => {
  //const token = getToken()
  const token = (await Auth.currentSession()).getIdToken().getJwtToken()

  return fetch(p, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (IS_DEBUG) {
        console.log(' API > res.status = ', res.status, p)
      }

      if (res.status === 401) {
        console.log(' API DELETE > 401 401 401 401401 = ')
        return Promise.reject(res)
        //return updateAccessToken(p, 'POST', data)
      }

      return res.json()
    })
    .then((res) => {
      if (res.result === false) {
        return Promise.reject(res)
      }
      return res
    })

    .catch((err) => {
      return Promise.reject(err)
    })
}

function getErrorResponse(err, status: number, msg) {
  return {
    result: false,
    status: status,
    err: err,
    message: msg,
  }
}

export async function fetchWithLog(p: string) {
  const res = await getReq(p)
  console.log(p.replaceAll(BASE_URL ?? '', ''), res)
  return res
}
